import { pushGA4Event } from './helpers';

/** domain list form tvs videos can live */
const domainList = ['videopolis.com'];

/** list of TVS events */
const TVSEVENTS = {
  COMPLETE: 'complete',
  FULLSCREEN: 'fullscreen',
  MUTE: 'mute',
  PAUSE: 'pause',
  PLAY: 'play',
  QUALITY_CHANGE: 'quality_change',
  READY: 'ready',
  SEEK: 'seek',
  SHARE: 'share',
  TIMEUPDATE: 'timeupdate'
};

/** list of event names to push to the dataLayer */
const TVSEVENTSTOPUSH = {
  complete: 'video_complete',
  fullscreen: 'video_user_interactions',
  mute: 'video_user_interactions',
  // pause: 'video_pause',
  play: 'video_start',
  quality_change: 'video_user_interactions',
  share: 'video_user_interactions',
  timeupdate: 'video_progress'
};

/** checks if the origin of the iframe is on the domainList */
const validDomain = (e) => {
  return domainList.reduce((contains, domain) => {
    return contains || e.origin.includes(domain);
  }, false);
};

/**
 * returns the percentage of the video played
 */
const getVideoPercentage = (current, duration) => {
  if (current === 0) return 0;
  return Math.round(Math.floor((current * 100) / duration)/10) * 10;
};

/**
 * returns the bucket of the percentage of the video played
 * we only inform when the percentage of the video played is [0,10,20,30..100]
 * not everysecond.
 */
const getVideoPercentagePerBucket = (current, duration) => {
  return Math.floor(getVideoPercentage(current, duration) / 10);
};

/**
 * Initiates the current video to be tracked
 * @param {Event} e
 */
const initVideoToTrack = (e) => {
  if ([TVSEVENTS.READY].includes(e.data.event)) {
    window.videosToTrack[`${e.data.data.media_id}`] = {
      blocked: false,
      last_event: e.data.event,
      last_bucket_completed: 0
    };
  }
};

/**
 * Creates the eventData object to be pushed to the dataLayer.
 * @param {Event} e
 * @returns
 */
const getEventDataToPush = (e) => {
  let eventData = {
    video_duration: e.data.data.media_duration,
    video_percent: getVideoPercentage(e.data.data.media_current_time, e.data.data.media_duration),
    video_title: e.data.data.media_name,
    video_url: e.data.data.media_filename
  };
  if (e.data.event === TVSEVENTS.FULLSCREEN) {
    eventData.behavior_type = `fullscreen ${e.data.data.media_fullscreen ? 'on' : 'off'}`;
  }
  if (e.data.event === TVSEVENTS.QUALITY_CHANGE) {
    eventData.behavior_type = `quality_change: ${e.data.data.media_resolution}`;
  }
  if (e.data.event === TVSEVENTS.MUTE) {
    eventData.behavior_type = `${TVSEVENTS.MUTE} ${e.data.data.media_mute ? 'on' : 'off'}`;
  }
  if (e.data.event === TVSEVENTS.SHARE) {
    eventData.behavior_type = `${TVSEVENTS.SHARE} :  ${e.data.data.sharing_network}`;
  }
  if (e.data.event === TVSEVENTS.PAUSE) {
    eventData.behavior_type = `${TVSEVENTS.PAUSE}`;
  }
  return eventData;
};

/**
 * returns if the event is blocked to be pushed.
 * @param {Event} e
 * @returns Boolean
 */
const isVideoEventPushBlocked = (e) => {
  let videoMediaId = e.data.data.media_id;
  let currentVideo = window.videosToTrack[videoMediaId];

  if (!currentVideo) return true;

  currentVideo.blocked = false;
  if (e.data.event === TVSEVENTS.QUALITY_CHANGE && currentVideo.last_event === TVSEVENTS.PLAY) {
    currentVideo.blocked = true;
  }
  if (e.data.event === TVSEVENTS.TIMEUPDATE) {
    currentVideo.blocked = true;
    let currentBucket = getVideoPercentagePerBucket(e.data.data.media_current_time, e.data.data.media_duration);
    if (currentVideo.last_bucket_completed < currentBucket) {
      currentVideo.blocked = false;
      currentVideo.last_bucket_completed = currentBucket;
    }
  }
  if (e.data.event === TVSEVENTS.PLAY && ![TVSEVENTS.PAUSE, TVSEVENTS.READY].includes(currentVideo.last_event)) {
    currentVideo.blocked = true;
  }
  if (
    e.data.event === TVSEVENTS.PAUSE &&
    getVideoPercentage(e.data.data.media_current_time, e.data.data.media_duration) > 95
  ) {
    currentVideo.blocked = true;
  }

  currentVideo.last_event = e.data.event;

  return currentVideo.blocked;
};

/**
 * receive the message from TVS iframe and handles the push to dataLayer
 * @param {object} e
 */
function handleTVSMessage({ e }) {
  if (!window.videosToTrack) {
    window.videosToTrack = {};
  }

  if (!validDomain(e)) return;
  if (!e.data?.event) return;
  if (e.data?.data?.player_template.toLowerCase() === 'hero') return;

  initVideoToTrack(e);

  if (!TVSEVENTSTOPUSH[e.data.event]) return;
  if(e.data.event === TVSEVENTSTOPUSH.play){
    TVSEVENTSTOPUSH.play = null;
  }

  let eventData = getEventDataToPush(e);
  let amIBlocked = isVideoEventPushBlocked(e);

  if (!amIBlocked) {
    pushGA4Event({
      eventName: TVSEVENTSTOPUSH[e.data.event],
      eventData
    });
  }
}

const TVSEventListener = () => {
  window.addEventListener('message', (event) => {
    handleTVSMessage({ e: event });
  });
};

export { TVSEventListener };
